export default {"src":"/_next/static/media/clock-icon.e6f1d5f4.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};